"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";

export default function Layout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  const isActive = (href: string) => pathname === href;

  return (
    <>
      <div className="mx-auto grid w-full max-w-6xl gap-2">
        <h1 className="text-3xl font-semibold">Settings</h1>
      </div>
      <div className="mx-auto grid w-full max-w-6xl items-start gap-6 md:grid-cols-[180px_1fr] lg:grid-cols-[250px_1fr]">
        <nav className="grid gap-4 text-sm text-muted-foreground">
          <Link
            href="/settings"
            className={
              isActive("/settings") ? "font-semibold text-primary" : ""
            }
          >
            Account
          </Link>
          {isActive("/settings") && (
            <>
              <Link href="#email" className="ml-6">
                Email
              </Link>
              <Link href="#changePassword" className="ml-6">
                Change password
              </Link>
              <Link href="#twoFactorAuthentication" className="ml-6">
                Two factor authentication
              </Link>
              <Link href="#linkedAccounts" className="ml-6">
                Linked accounts
              </Link>
            </>
          )}
          <Link
            href="/settings/contracts"
            className={
              isActive("/settings/contracts")
                ? "font-semibold text-primary"
                : ""
            }
          >
            Contracts
          </Link>
          <Link
            href="/settings/timesheets"
            className={
              isActive("/settings/timesheets")
                ? "font-semibold text-primary"
                : ""
            }
          >
            Timesheets
          </Link>
          <Link
            href="/settings/clients"
            className={
              isActive("/settings/clients") ? "font-semibold text-primary" : ""
            }
          >
            Clients
          </Link>
        </nav>
        <div className="grid gap-6">{children}</div>
      </div>
    </>
  );
}
